var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4005",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4009"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4019"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path4017"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g4011",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4015",
    clipPath: "url(#clipPath4019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4021",
    transform: "translate(502,257.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-135.31 -109.69,-245 -245,-245 -71.33,0 -135.54,30.48 -180.31,79.13 -11.76,12.77 -22.17,26.8 -31.03,41.85 C -477.73,-87.64 -490,-45.25 -490,0 c 0,135.31 109.69,245 245,245 45.26,0 87.65,-12.27 124.02,-33.67 15.05,-8.85 29.07,-19.26 41.84,-31.03 C -30.49,135.55 0,71.33 0,0",
    style: {
      fill: "#f0cd00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4023"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4025",
    transform: "translate(502,257.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-132.26 -104.79,-240.04 -235.88,-244.83 -131.09,4.79 -235.88,112.57 -235.88,244.83 0,132.26 104.79,240.04 235.88,244.83 C -104.79,240.04 0,132.26 0,0",
    style: {
      fill: "#ffde50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4029",
    transform: "translate(422.8604,437.5698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -346.17,-346.17 c -11.761,12.77 -22.171,26.8 -31.03,41.85 L -41.841,31.03 C -26.79,22.18 -12.771,11.77 0,0",
    style: {
      fill: "#ffea94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4031"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4033",
    transform: "translate(485.0996,346.8398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -317.68,-317.68 c -22.49,8.84 -43.36,20.91 -62.03,35.64 L -35.63,62.04 C -20.899,43.37 -8.83,22.5 0,0",
    style: {
      fill: "#ffea94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4035"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4037",
    transform: "translate(447.3799,257.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-105.14 -85.24,-190.38 -190.38,-190.38 -36.62,0 -70.82,10.34 -99.849,28.26 -12.651,7.8 -24.311,17.05 -34.771,27.51 -7.689,7.68 -14.729,16.03 -21.02,24.94 -8.66,12.27 -15.91,25.61 -21.5,39.78 -8.28,20.95 -12.94,43.73 -13.22,67.55 -0.02,0.78 -0.02,1.56 -0.02,2.34 0,105.14 85.23,190.38 190.38,190.38 0.78,0 1.57,0 2.35,-0.02 23.82,-0.28 46.591,-4.95 67.54,-13.22 14.17,-5.6 27.511,-12.84 39.78,-21.5 8.91,-6.3 17.25,-13.33 24.94,-21.02 10.46,-10.45 19.71,-22.12 27.51,-34.77 C -10.34,70.82 0,36.62 0,0",
    style: {
      fill: "#faa300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4039"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4041",
    transform: "translate(391.6104,391.8901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -269.23,-269.23 c -7.69,7.68 -14.73,16.03 -21.02,24.94 -8.66,12.27 -15.91,25.61 -21.5,39.78 -8.28,20.95 -12.94,43.73 -13.221,67.55 -0.019,0.78 -0.019,1.56 -0.019,2.34 0,105.14 85.229,190.38 190.38,190.38 0.78,0 1.57,0 2.349,-0.02 23.821,-0.28 46.591,-4.95 67.54,-13.22 14.17,-5.6 27.511,-12.84 39.781,-21.5 C -16.03,14.72 -7.69,7.69 0,0",
    style: {
      fill: "#ffbd00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4043"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4045",
    transform: "translate(447.375,257.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-105.14 -85.24,-190.38 -190.38,-190.38 -3.61,0 -7.19,0.1 -10.75,0.3 100.14,5.57 179.62,88.55 179.62,190.08 0,101.53 -79.48,184.51 -179.62,190.08 3.56,0.2 7.14,0.3 10.75,0.3 C -85.24,190.38 0,105.14 0,0",
    style: {
      fill: "#f68e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4049",
    transform: "translate(323.2607,493.2026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -21.076,5.907 -43.301,9.066 -66.264,9.066 -135.309,0 -245,-109.69 -245,-245 0,-135.31 109.691,-245 245,-245 135.31,0 245,109.69 245,245 0,102.26 -62.65,189.888 -151.661,226.593",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4051"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4053",
    transform: "translate(447.375,257.269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-105.143 -85.235,-190.378 -190.378,-190.378 -105.143,0 -190.379,85.235 -190.379,190.378 0,105.143 85.236,190.378 190.379,190.378 C -85.235,190.378 0,105.143 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4055"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4057",
    transform: "translate(270.9785,176.6621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -63.597 V 65.081 H -15.501 0 c 17.942,0 32.54,-14.598 32.54,-32.54 C 32.54,14.598 17.942,0 0,0 m -63.597,161.216 h 48.096 c 15.477,0 28.067,-12.591 28.067,-28.068 0,-15.476 -12.59,-28.067 -28.067,-28.067 H -63.597 Z M 72.54,32.541 c 0,25.39 -13.123,47.761 -32.932,60.726 8.141,11.216 12.958,24.993 12.958,39.881 0,25.711 -14.332,48.134 -35.423,59.71 v 24.654 c 0,11.046 -8.955,20 -20,20 -11.046,0 -20,-8.954 -20,-20 v -16.296 h -24.138 v 16.296 c 0,11.046 -8.954,20 -20,20 -11.046,0 -20,-8.954 -20,-20 v -16.296 h -23.504 c -11.046,0 -20,-8.954 -20,-20 0,-11.046 8.954,-20 20,-20 h 6.902 V 85.081 0 h -6.902 c -11.046,0 -20,-8.954 -20,-20 0,-11.046 8.954,-20 20,-20 h 23.504 v -16.296 c 0,-11.046 8.954,-20 20,-20 11.046,0 20,8.954 20,20 V -40 h 24.138 v -16.296 c 0,-11.046 8.954,-20 20,-20 11.045,0 20,8.954 20,20 v 18.36 c 31.75,7.725 55.397,36.383 55.397,70.477",
    style: {
      fill: "#f68e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4059"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4061",
    transform: "translate(295.9805,176.6621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -63.597 V 65.081 H -15.501 0 c 17.942,0 32.54,-14.598 32.54,-32.54 C 32.54,14.598 17.942,0 0,0 m -63.597,161.216 h 48.096 c 15.477,0 28.067,-12.591 28.067,-28.068 0,-15.476 -12.59,-28.067 -28.067,-28.067 H -63.597 Z M 72.54,32.541 c 0,25.39 -13.123,47.761 -32.932,60.726 8.14,11.216 12.958,24.993 12.958,39.881 0,25.711 -14.333,48.134 -35.423,59.71 v 24.654 c 0,11.046 -8.955,20 -20,20 -11.046,0 -20,-8.954 -20,-20 v -16.296 h -24.138 v 16.296 c 0,11.046 -8.954,20 -20,20 -11.046,0 -20,-8.954 -20,-20 v -16.296 h -23.504 c -11.046,0 -20,-8.954 -20,-20 0,-11.046 8.954,-20 20,-20 h 6.902 V 85.081 0 h -6.902 c -11.046,0 -20,-8.954 -20,-20 0,-11.046 8.954,-20 20,-20 h 23.504 v -16.296 c 0,-11.046 8.954,-20 20,-20 11.046,0 20,8.954 20,20 V -40 h 24.138 v -16.296 c 0,-11.046 8.954,-20 20,-20 11.045,0 20,8.954 20,20 v 18.36 c 31.75,7.725 55.397,36.383 55.397,70.477",
    style: {
      fill: "#ffea94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4065",
    transform: "translate(295.9805,176.6621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -63.597 V 65.081 H -15.501 0 c 17.942,0 32.54,-14.598 32.54,-32.54 C 32.54,14.598 17.942,0 0,0 Z m -63.597,161.216 h 48.096 c 15.477,0 28.067,-12.591 28.067,-28.068 0,-15.476 -12.59,-28.067 -28.067,-28.067 h -48.096 z m -40,-145.786 V 0 h -6.902 c -11.046,0 -20,-8.954 -20,-20 0,-11.046 8.954,-20 20,-20 h 23.504 v -16.296 c 0,-11.046 8.954,-20 20,-20 11.046,0 20,8.954 20,20 V -40 h 24.138 v -16.296 c 0,-11.046 8.954,-20 20,-20 11.045,0 20,8.954 20,20 v 18.36 c 31.75,7.725 55.397,36.383 55.397,70.477 0,25.39 -13.123,47.761 -32.932,60.726 8.14,11.216 12.958,24.993 12.958,39.881 0,25.711 -14.333,48.134 -35.423,59.71 v 24.654 c 0,11.046 -8.955,20 -20,20 -11.046,0 -20,-8.954 -20,-20 v -16.296 h -24.138 v 16.296 c 0,11.046 -8.954,20 -20,20 -11.046,0 -20,-8.954 -20,-20 v -16.296 h -23.504 c -11.046,0 -20,-8.954 -20,-20 0,-11.046 8.954,-20 20,-20 h 6.902 V 85.081 45.432",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4067"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.05201d67ba5aa2a6e9ceb51502019329.svg";
export { ForwardRef as ReactComponent };